// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.back-arrow {
  position: absolute;
  left: 2.2rem;
  display: flex;
  align-items: center;
  gap: 0.4rem;
  cursor: pointer;
  font-size: 1.75rem;
  z-index: 1000;
  padding-left: 0.5rem;
  text-decoration: none;
  transform: translateY(-50%);
}

.back-arrow .back-text {
  font-family: 'Staatliches', sans-serif;
  font-variant: small-caps;
  font-size: 1.15rem;
}

.back-arrow .material-symbols-outlined {
  /* icon should not be underlined */
  border-bottom: none;
}

.back-arrow:hover {
  text-decoration: none;
}

.back-arrow:hover .back-text {
  text-decoration: underline;
  text-underline-offset: 4px;
}

.back-arrow.gelb {
  color: var(--gelb);
}

.back-arrow.blutorange {
  color: var(--blutorange);
}

.back-arrow.hellblau {
  color: var(--hellblau);
}

.back-arrow span {
  color: inherit;
}

@media (max-width: 600px) {
  .back-arrow {
    position: static;
    top: auto;
    left: 0;
    margin-bottom: 0.5rem;
    padding-left: 0;
    transform: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/BackArrow.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,oBAAoB;EACpB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;EACtC,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,gBAAgB;IAChB,SAAS;IACT,OAAO;IACP,qBAAqB;IACrB,eAAe;IACf,eAAe;EACjB;AACF","sourcesContent":[".back-arrow {\n  position: absolute;\n  left: 2.2rem;\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  cursor: pointer;\n  font-size: 1.75rem;\n  z-index: 1000;\n  padding-left: 0.5rem;\n  text-decoration: none;\n  transform: translateY(-50%);\n}\n\n.back-arrow .back-text {\n  font-family: 'Staatliches', sans-serif;\n  font-variant: small-caps;\n  font-size: 1.15rem;\n}\n\n.back-arrow .material-symbols-outlined {\n  /* icon should not be underlined */\n  border-bottom: none;\n}\n\n.back-arrow:hover {\n  text-decoration: none;\n}\n\n.back-arrow:hover .back-text {\n  text-decoration: underline;\n  text-underline-offset: 4px;\n}\n\n.back-arrow.gelb {\n  color: var(--gelb);\n}\n\n.back-arrow.blutorange {\n  color: var(--blutorange);\n}\n\n.back-arrow.hellblau {\n  color: var(--hellblau);\n}\n\n.back-arrow span {\n  color: inherit;\n}\n\n@media (max-width: 600px) {\n  .back-arrow {\n    position: static;\n    top: auto;\n    left: 0;\n    margin-bottom: 0.5rem;\n    padding-left: 0;\n    transform: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
